import { Link } from "react-router-dom";
import css from "./Clickard.module.css";

const Clickard = ({ children, img, link, text, isExternal }) => {
  const content = (
    <>
      {img?.src && img?.alt ? (
        <img className={css.img} src={img.src} alt={img.alt} />
      ) : (
        <div className={css.img}>(PLACEHOLDER)</div>
      )}
      <strong className={css.text}>{text}</strong>
    </>
  );

  if (isExternal) {
    return (
      <a
        href={link}
        className={css.main}
        target="_blank"
        rel="noopener noreferrer"
      >
        {content}
        {children}
      </a>
    );
  }

  return (
    <Link to={link} className={css.main}>
      {content}
      {children}
    </Link>
  );
};

export default Clickard;
